export default __webpack_public_path__ + "static/media/98-11_header_invoice.073b2c7f.png";